module.exports = __webpack_public_path__ + "img/bb_header.ab5f367e.png";